export default __webpack_public_path__ + "static/media/la_capelle13.7ff9663b.jpg";